import React from "react";
import { Modal, Button, Input, Form, message } from "antd";
const { Item } = Form;
import { AddExchangeRateWallets, CheckExchangeRateWallet } from "$DATA/wallet";
import {
    usdtTRC20Reg,
    usdtERC20Reg,
    onlyAlphanumeric,
    cryptoWalletNameThai,
} from "$ACTIONS/reg";

class AddWalletAddress extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            walletName: "",
            walletAddress: "",
            walletNameError: "",
            walletAddressError1: "",
            walletAddressError2: "",
            btnSubmitable: false,
            walletAddressList: props.walletAddressList,
        };
        this.exchangeRateWalletTest = this.exchangeRateWalletTest.bind(this); //輸入格式驗證
        this.handleOk = this.handleOk.bind(this); //提交
        this.changeModalBtnStatus = this.changeModalBtnStatus.bind(this); //按鈕提交狀態
    }
    componentDidMount() {
        typeof this.props.submitAddWalletAddress === "function" &&
            this.props.submitAddWalletAddress(this.handleOk);
        !this.state.walletAddressList && this.getTDBWallet();
    }
    exchangeRateWalletTest = (e, t) => {
        const walleNameTest = cryptoWalletNameThai;
        const walletAddressTest1 = onlyAlphanumeric;
        const walletAddressTest2 =
            this.props.ctcMethod === "USDT-ERC20" ? usdtERC20Reg : usdtTRC20Reg;
        let value = e.target.value;
        if (t == "name") {
            this.setState({ walletName: value }, () => {
                if (walleNameTest.test(value) === true) {
                    this.setState({ walletNameError: false }, () => {
                        this.changeModalBtnStatus();
                    });
                } else {
                    this.setState({ walletNameError: true }, () => {
                        this.changeModalBtnStatus();
                    });
                }
            });
        }
        if (t == "address") {
            this.setState({ walletAddress: value }, () => {
                if (walletAddressTest1.test(value) === true) {
                    this.setState({ walletAddressError1: false }, () => {
                        this.changeModalBtnStatus();
                    });
                } else {
                    this.setState({ walletAddressError1: true }, () => {
                        this.changeModalBtnStatus();
                    });
                }
                if (walletAddressTest2.test(value) === true) {
                    this.setState({ walletAddressError2: false }, () => {
                        this.changeModalBtnStatus();
                    });
                } else {
                    this.setState({ walletAddressError2: true }, () => {
                        this.changeModalBtnStatus();
                    });
                }
            });
        }
    };
    handleOk = (verificationCode) => {
        this.props.setLoading(true);
        const datas = {
            walletName: this.state.walletName,
            walletAddress: this.state.walletAddress,
            cryptocurrencyCode: this.props.ctcMethod,
            isDefault: this.state.walletAddressList?.length ? false : true,
            passCode: verificationCode,
        };
        AddExchangeRateWallets(datas, (res) => {
            this.props.setLoading(false);
            if (res?.isSuccess == true) {
                message.success("เพิ่มที่อยู่กระเป๋าเงินสำเร็จ"); //添加成功
                this.props.getTDBWallet(this.props.ctcMethod); //更新address list
                this.props.changeVerify(false, false, false); //關閉彈窗
            } else {
                this.props.changeVerify(false, true, false); //關閉彈窗
                if (res?.errors?.length > 0) {
                    message.error(res?.errors?.[0]?.description);
                }
            }
        });
    };
    getTDBWallet = () => {
        this.props.setLoading(true);
        const datas = {
            CryptoCurrencyCode: this.props.ctcMethod,
        };
        CheckExchangeRateWallet(datas, (res) => {
            this.props.setLoading(false);
            if (res && res.result && res.result.length) {
                this.setState({
                    walletAddressList: res.result.sort((a, b) => {
                        return b.isDefault - a.isDefault;
                    }),
                });
            } else {
                this.setState({
                    walletAddressList: [],
                });
            }
        });
    };
    changeModalBtnStatus = () => {
        const {
            walletNameError,
            walletAddressError1,
            walletAddressError2,
            walletAddress,
            walletName,
        } = this.state;
        if (
            !walletAddressError1 &&
            !walletAddressError2 &&
            !walletNameError &&
            walletAddress &&
            walletName
        ) {
            this.setState({ btnSubmitable: true });
        } else {
            this.setState({ btnSubmitable: false });
        }
    };
    render() {
        const isErc = this.props.ctcMethod === "USDT-ERC20";
        const {
            walletName,
            walletAddress,
            walletNameError,
            walletAddressError1,
            walletAddressError2,
            btnSubmitable,
        } = this.state;
        return (
            <>
                <Modal
                    title={`เพิ่มที่อยู่กระเป๋าเงิน ${this.props.ctcMethod}`} //添加XX钱包地址"
                    visible={this.props.addWalletAddressVisible}
                    onCancel={() => {
                        this.props.closeAddwallet();
                    }}
                    footer={null}
                    className="add-ctc-WalletModal"
                    width={400}
                >
                    <Form className="WalletModal-form-wrap">
                        <Item label="ชื่อกระเป๋า" validateStatus={walletNameError ? 'error' : ''}>
                            {/* 钱包名称 */}
                            <Input
                                size="large"
                                className="tlc-input-disabled"
                                placeholder="กรุณาใส่ชื่อกระเป๋า" //请输入名称
                                onChange={(e) =>
                                    this.exchangeRateWalletTest(e, "name")
                                }
                                maxLength={20}
                                value={walletName}
                            />
                            <div className="wallet-info-container">
                                <div className="wallet-info">
                                    <img
                                        style={{ marginRight: "0.4rem" }}
                                        src={`/th/img/icon/${
                                            !walletName
                                                ? "greyTick"
                                                : walletNameError
                                                ? "redCross"
                                                : "greenTick"
                                        }.svg`}
                                    />
                                    <p>ไม่อนุญาตให้ใช้อักขระพิเศษ</p>
                                    {/* 不允许使用特殊字符 */}
                                </div>
                                <div className="wallet-info">
                                    <img
                                        style={{ marginRight: "0.4rem" }}
                                        src={`/th/img/icon/${
                                            !walletName
                                                ? "greyTick"
                                                : "greenTick"
                                        }.svg`}
                                    />
                                    <p>ใส่ข้อมูลได้ 20 ตัวอักษร</p>
                                    {/* 最多20个字符 */}
                                </div>
                            </div>
                        </Item>
                        <Item label="ที่อยู่กระเป๋าเงิน" validateStatus={walletAddressError1 || walletAddressError2 ? 'error' : ''}>
                            {/* 钱包地址 */}
                            <Input
                                size="large"
                                className="tlc-input-disabled"
                                placeholder="กรุณาใส่ที่อยู่กระเป๋าเงิน" //请输入地址
                                onChange={(e) =>
                                    this.exchangeRateWalletTest(e, "address")
                                }
                                maxLength={isErc ? 42 : 34}
                                value={walletAddress}
                            />
                            <div className="wallet-info-container">
                                <div className="wallet-info">
                                    <img
                                        style={{ marginRight: "0.4rem" }}
                                        src={`/th/img/icon/${
                                            !walletAddress
                                                ? "greyTick"
                                                : walletAddressError1
                                                ? "redCross"
                                                : "greenTick"
                                        }.svg`}
                                    />
                                    <p>ไม่อนุญาตให้เว้นวรรคและใช้อักขระพิเศษ</p>
                                    {/* 不允许使用空格和特殊字符 */}
                                </div>
                                <div className="wallet-info">
                                    <img
                                        style={{ marginRight: "0.4rem" }}
                                        src={`/th/img/icon/${
                                            !walletAddress
                                                ? "greyTick"
                                                : walletAddressError2
                                                ? "redCross"
                                                : "greenTick"
                                        }.svg`}
                                    />
                                    <p>
                                        {
                                            isErc
                                                ? "ขึ้นต้นด้วยตัว 0x ตามด้วยตัวอักษร (a-f) และตัวเลข (0-9) คละกันรวม 42 ตัว" //以”0x”开头, 为一串42个字母数字字符
                                                : "ขึ้นต้นด้วยตัว T ตามด้วยตัวอักษรและตัวเลข คละกัน 34 ตัว" //以"T"开头, 为一串34个字母数字字符
                                        }
                                    </p>
                                </div>
                            </div>
                        </Item>
                        <Item>
                            <div>
                                {/* <Button size="large" htmlType="submit" block onClick={leaveAddWallet}>取消</Button> */}
                                <Button
                                    size="large"
                                    htmlType="submit"
                                    block
                                    onClick={this.props.openOTP}
                                    disabled={!btnSubmitable}
                                    type="primary"
                                >
                                    ส่ง
                                    {/* 添加 */}
                                </Button>
                            </div>
                        </Item>
                    </Form>
                </Modal>
            </>
        );
    }
}

export default AddWalletAddress;
